<template>
  <div>
    <a-modal
      width="50%"
      centered
      v-model="show"
      :title="$t('pdf')"
      :maskClosable="false"
      :okText="$t('print')"
      :cancelText="$t('cancel')"
      :cancelButtonProps="{ class: 'btn ts-whitespace-no-wrap btn-default' }"
      :confirmLoading="waiting"
      :footer="null"
      style="top: 3vh;"
      :zIndex="2000"
      @cancel="onCanel"
    >
      <div id="container">
        <i class="fa fa-spinner spin fa-2x text-white" v-if="printing"></i>
        <iframe :src="src" v-if="!printing"></iframe>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'pdfPreview',
  props: ['value', 'invoiceId'],
  data() {
    return {
      show: false,
      waiting: false,
      printing: false,
      src: ''
    }
  },
  methods: {
    ...mapActions('invoiceConfirm', ['previewPdf']),
    onCanel() {
      this.src = ''
      this.$emit('cancel', false)
    }
  },
  watch: {
    value: function(value) {
      if (value && this.invoiceId > 0) {
        this.show = value
        this.printing = true
        this.previewPdf(this.invoiceId)
          .then(response => {
            this.src = response.url
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => {
            this.printing = false
          })
      }
    }
  }
}
</script>

<style scoped>
#container {
  width: 100%;
  height: 70vh;
  background: black;
  text-align: center;
}
#container iframe {
  width: 100%;
  height: 70vh;
  border: 2px solid #acacac;
}
#container i {
  margin-top: 32vh;
}
</style>
